import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "loader-animation",
  templateUrl: "./loader-animation.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class LoaderAnimationComponent {
  @Input() showMessage: boolean = true;
  @Input() message: string;
  @Input() loading: boolean;

  constructor() {}
}
